// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxO8SS17vkxA5mvrCp54_hQgZvpLAZGNw",
  authDomain: "yvomanew1.firebaseapp.com",
  databaseURL: "https://yvomanew1-default-rtdb.firebaseio.com",
  projectId: "yvomanew1",
  storageBucket: "yvomanew1.appspot.com",
  messagingSenderId: "614613159137",
  appId: "1:614613159137:web:6b2adc2ef14c1df678fba0",
  measurementId: "G-X2L14LKY8V"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export { app };